export const NPS_PROMPT_MAX_INTERVAL_IN_MINUTES = 30;
